import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import PublicAnnouncementListView from './publicAnnouncementListView';
import FooterComponent from '../../commons/footer/footerComponent';
import HeaderComponent from '../../commons/header/headerComponent';
import { getCookie } from '../../../utils/cookies';
import api from '../../../utils/api';
import apiResponseMessage from '../../../utils/apiResponse';

class PublicAnnouncementListComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announcements: [],
            isLoading: true,
            success: true,
            message: null,
        };
    }

    render() {
        const { isLoading, announcements, message, success } = this.state;

        return (
            <div>
                <HeaderComponent />
                <PublicAnnouncementListView
                    isLoading={isLoading}
                    announcements={announcements}
                    onAnnouncementClick={this.openAnnouncementDetails}
                    message={message}
                    success={success}
                />
                <FooterComponent />
            </div>
        );
    }

    openAnnouncementDetails = (id) => {
        this.props.history.push('/announcement/' + id);
    };

    async componentDidMount() {
        this.setState({
            ...this.state,
            ...{
                isLoading: true,
            },
        });

        try {
            let response = await api.get('/announcement/list', {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },
                params: {
                    status: 'published',
                    platform: 'website',
                },
            });

            this.setState({
                ...this.state,
                ...{
                    isLoading: false,
                    success: true,
                    announcements: response.data,
                },
            });
        } catch (e) {
            this.setState({
                ...this.state,
                ...{
                    success: false,
                    message:
                        apiResponseMessage(e?.response?.data, 'announcements.requestFailed'),
                    isLoading: false,
                },
            });
        }
    }
}

export default withRouter(PublicAnnouncementListComponent);
